import { Route, Routes } from 'react-router'

import { NotFound } from 'js/core/NotFound'

import Item from './Item'
import List from './List'

const Component = () => (
    <Routes>
        <Route index element={<List />} />
        <Route path="view/:guid/:slug" element={<Item />} />
        <Route
            path="view/:containerGuid/:containerSlug/:guid"
            element={<Item />}
        />
        <Route path="*" element={<NotFound />} />
    </Routes>
)

export default Component
